import Importt from "@/components/import";
import axios from "axios";
import { baseUrlt, downUrl } from "../../../api";



export let mixinImport = {
  data() {
    return {
      fileList: [],
      btnTitle: '导入数据',
      params: {},
      baseUrlt,
      downUrl
    };
  },
  components: {
    Importt
  },
  created() {
  },
  mounted() {

  },
  methods: {
    // downloadFile() {
    //   window.location.href = `${window.origin + this.downloadUrl}`
    // },
    downloadFile() {
      const url =  this.downloadUrl;
      const link = document.createElement('a');
      // let fname = this.downloadName;
      link.href = downUrl + url;
      console.log(downUrl + url)
      // link.setAttribute('download', fname);
      document.body.appendChild(link);
      link.click();
    },
    axiosDownloadFile(method = 'get') {
      axios({
        method: method,
        url: downUrl + this.downloadUrl,
        responseType: 'blob',
        withCredentials: true,
        headers: {
          token: this.$store.state.userInfo ? this.$store.state.userInfo.userToken : ''
        }
      }).then(res => {
        // 这里 data 是返回来的二进制数据
        var blob = new Blob([res], {
          type: "application/x-msdownload;charset=UTF-8",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.downloadName); // 设置下载文件名
        document.body.appendChild(link);
        link.click();
      })
    },
    uploadSectionFile(params) {
      const file = params.file,
        // 根据后台需求数据格式
        form = new FormData();
      // 文件对象
      form.append("file", file);
      // 本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action
      // 项目封装的请求方法，下面做简单介绍
      this.imageUpload(form, params)
        .then(res => {
          //自行处理各种情况
          const code = res.code;
          if (code == 0) {
            // this.$message.success(res.msg)
            this.$message.success('导入成功！')
            this.handleQuery()
          } else if (res.code == 60001) {
            window.location.href = '/#/login'
          } else {
            // this.$message.warning(res.msg)
          }
        })
        .catch(() => {
          // xxx
        });
    },
    imageUpload(form, params) {
      const url = params.action
      // 根据后台需求的数据格式确定headers
      return axios.post(url, form, {
        headers: { "content-type": "multipart/form-data" },
        withCredentials: true,
        token: this.$store.state.userInfo ? this.$store.state.userInfo.userToken : ''
      })
    },
    setFileList(res) {
      // console.log(res)
      if (res.code == 0 && res.data) {
        this.fileList.push(`${this.$store.state.imgApiUrl + res.data.store_result}`)
      }
    },
    delFile(res) {
      console.log(res)
      this.fileList = []
      if (res.length > 0) {
        res.map(item => {
          this.fileList.push(this.$store.state.imgApiUrl + item.response.data.store_result)
        })
      }
    }
  }
};
